import {SALES_DETAIL_TYPE_KEY_TYPE} from "@/shared/model";
import dayjs from "dayjs";
import * as z from "zod";

const detailCreateSchema = z.object({
	type: SALES_DETAIL_TYPE_KEY_TYPE,
	content: z.string()
});

const commonSchema = z.object({
	department: z.string(),
	managerId: z.string().nullable(),
	details: z.array(detailCreateSchema)
});

const yearlySchema = commonSchema.extend({
	period: z.literal("YEARLY"),
	year: z.string()
});

const monthlySchema = commonSchema.extend({
	period: z.literal("MONTHLY"),
	yearMonth: z.string()
});

const weeklySchema = commonSchema.extend({
	period: z.literal("WEEKLY"),
	dateRangeValue: z.object({
		from: z.string().optional(),
		to: z.string().optional()
	})
});

const schema = z.discriminatedUnion("period", [yearlySchema, monthlySchema, weeklySchema]);

const model = schema.transform((values) => ({
	...values
}));

export const SalesManagementCreateModel = {schema, model};
export type ISalesManagementCreateModel = z.infer<typeof SalesManagementCreateModel.model>;
export const DEFAULT_SALES_MANAGEMENT_CREATE: ISalesManagementCreateModel = {
	year: dayjs().get("year").toString(),
	period: "YEARLY",
	department: "",
	managerId: null,
	details: []
};
